import { LitElement, html, css } from 'lit';
import {msg,str} from '@lit/localize';
import { validateForm, validatePassword, validateEmail, gRecaptcha, validationHandler, validationHandlerClear, hideRevealPassword } from '../../utilities/formsUtilities';
import { accessibility,formStyles} from '../../utilities/styles';
import { eyeSvg } from '../../utilities/icons';

export class AllInSignupForm extends LitElement {
    static properties = {
        action: { type: String },
        nonce: { type: String },
        successRedirect: { type: String },
        alreadyLoggedInMessage: { type: String },
        tooltip_1: { type: String },
        tooltip_2: { type: String },
        tooltip_3: { type: String },
        tooltip_4: { type: String },

        _successMessage: { state: true },
        _errorMessage: { state: true },
        
    }

    constructor() {
        super();
        this._loggedIn = document.cookie.split(';').find((row) => row.startsWith('allin_uid'))?.split('=')[1] ? true : false;
        this._loginSuccess = false;
        this._errorMessage = '';
    }

    get form() {
        return this.shadowRoot.querySelector('form');
    }

    get formResponse() {
        return this.shadowRoot.querySelector('.message');
    }

    get noticeArea() {
        return this.shadowRoot.querySelector('.notice');
    }

    get submitButton() {
        return this.shadowRoot.querySelector('input[type="submit"]');
    }

    render() {
        let markup;
        if(this._loggedIn) {
            markup = html`
                <p>${this.alreadyLoggedInMessage}</p>
            `
        }
        else{
            markup = html`
                <form action="${this.action}" method="post" @submit=${this._signup}>
                    <div class="message notice" aria-live="polite"></div>
                    <h2><slot name="main-header"></slot></h2>
                    <slot name="main-header-description"></slot>
                    <p class="small">*${msg('Please note: asterisk marks a required field',{desc:'Appears on forms to describe required fields that are marked with *'})}</p>
                    <fieldset>
                        <legend><slot name="details-header"></slot></legend>
                        <p class="small"><slot name="details-description"></slot></p>
                        <div class="bg">
                            <div class="input-group">
                                <label for="firstname">${msg('First name',{desc:'label for first name input field'})}*</label>
                                <input type="text" name="firstname" id="firstname" aria-required autocomplete="given-name">
                            </div>
                            <div class="input-group">
                                <label for="lastname">${msg('Last name',{desc:'label for last name input field'})}*</label>
                                <input type="text" name="lastname" id="lastname" aria-required autocomplete="family-name">
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend><slot name="account-details-header"></slot></legend>
                        <p class="small"><slot name="account-details-description"></slot></p>
                        <div class="bg">
                            <div class="input-group">
                                <div>
                                    <label for="email">${msg('Please enter your email address',{desc:'label for email on sign up form'})}*</label>
                                    <allin-tooltip tooltip="${this.tooltip_1}" buttontext="${msg('Which email address should I use?')}"></allin-tooltip>
                                </div>
                                <input type="email" name="email" id="email" aria-required autocomplete="email" @change=${this._onEmailChange}>
                            </div>
                            <div class="input-group">
                                <label for="email_confirm">${msg('Confirm email address',{desc:'label for confirm email input field'})}*</label>
                                <input type="email" name="email_confirm" id="email_confirm" aria-required autocomplete="email" @change=${this._onEmailConfirmChange}>
                            </div>
                            <div class="input-group">
                                <label for="password">${msg('Please create a password',{desc:'label for password input field'})}*</label>
                                <div class="pword_wrapper">
                                    <input type="password" name="password" id="password" aria-required @change=${this._onPasswordChange}>
                                    <button data-switch="password" aria-label="${msg('Show password')}" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>
                                    ${eyeSvg} ${msg('Show password')}</button>
                                </div>
                            </div>
                            <div class="input-group">
                                <label for="password_confirm">${msg('Confirm password')}*</label>   
                                <div class="pword_wrapper">
                                    <input type="password" name="password_confirm" id="password_confirm" aria-required @change=${this._onPasswordConfirmChange}>
                                    <button data-switch="password_confirm" aria-label="${msg('Show password')}" aria-pressed="false" type="button" class="show-password" @click=${hideRevealPassword}>
                                    ${eyeSvg} ${msg('Show password')}</button>
                                </div>
                            </div>
                        </div>
                        <input type="text" name="username" id="username" class="hp" autocomplete="off">
                    </fieldset>
                    <fieldset>
                        <legend><slot name="block-4-header"></slot></legend>
                        <div class="bg">
                            <div class="input-group">
                                <label for="language_preference"><slot name="block-4-description"></slot></label>
                                <select name="language_preference" id="language_preference">
                                    <option value="en" selected>${msg('English')}</option>
                                    <option value="cy">${msg('Cymraeg')}</option>
                                    <!-- <option value="ga">${msg('Gaeilge')}</option> -->
                                    <option value="gd">${msg('Gaelic')}</option>
                                </select>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend><slot name="email-preferences-header"></slot></legend>
                        <p class="small"><slot name="email-preferences-description"></slot></p>
                        <div class="bg">
                            <div class="input-group">
                                <input type="checkbox" name="email_optin" id="email_optin" aria-required data-label="${msg('Platform notifications opt in')}" checked disabled><div><label for="email_optin">${msg('Account alerts and notification emails',{desc:'label for email opt-in checkbox'})}*</label><allin-tooltip tooltip="${this.tooltip_2}"></allin-tooltip></div>
                            </div> 
                            <div class="input-group">
                                <input type="checkbox" name="marketingCommunications" id="marketingCommunications" data-label="${msg('Newsletter and marketing emails from All In')}"><div><label for="marketingCommunications">${msg('Newsletter and marketing emails from All In',{desc:'label for marketing communication checkbox'})}</label><allin-tooltip tooltip="${this.tooltip_3}"></allin-tooltip></div>
                            </div>
                            <div class="input-group">
                                <input type="checkbox" name="trainingCommunications" id="trainingCommunications" data-label="${msg('Skills development emails')}"><div><label for="supportCommunication">${msg('Skills development emails',{desc:'label for support communication checkbox'})}</label><allin-tooltip tooltip="${this.tooltip_4}"></allin-tooltip></div>
                            </div>
                        </div>
                    </fieldset>
                    <fieldset>
                        <legend><slot name="terms-and-conditions-legend"></slot></legend>
                        <slot name="terms-and-conditions-description" ></slot>
                        <div class="input-group">
                            <input type="checkbox" name="platform" id="platform" aria-required data-label="${msg('Terms and conditions')}" data-error_message="${msg('You must accept the terms and conditions to continue',{desc:'error message for terms and conditions checkbox'})}"><label for="platform">${msg('I have read and agree to the terms and conditions.',{desc:'label for terms and conditions checkbox'})}</label>
                        </div>
                    </fieldset>
                    <input type="submit" value="${msg('Create an account',{desc:'submit button for sign up form'})}">
                    <div class="notice" aria-live="assertive">
                    </div>
                    <slot></slot>
                </form>
                
            `
        }
        return html` 
            <div class="signup-form">
                ${markup}
            </div>
        `
    }
    _onEmailChange(e){
        e.preventDefault();
        let emailField = e.target;
        validationHandlerClear(emailField);
        let valid = validateEmail(emailField.value);
        if(!valid){
            validationHandler(emailField,msg(str`Please enter a valid email address`));   
            this.submitButton.disabled = true;
        }
        let emailConfirmField = this.form.querySelector('#email_confirm');
        if(emailConfirmField.value){
            if(emailField.value!==emailConfirmField.value){
                valid=false;
                validationHandler(emailConfirmField,msg(str`Email addresses do not match`));
                this.submitButton.disabled = true;
            }
            else{
                validationHandlerClear(emailConfirmField);
            }
        }
        if(valid){
            this.submitButton.disabled = false;
        }
    }

    _onEmailConfirmChange(e){
        e.preventDefault();
        let emailConfirmField = e.target;
        validationHandlerClear(emailConfirmField);
        let emailField = this.form.querySelector('#email');
        if(emailField.value!==emailConfirmField.value){
            validationHandler(emailConfirmField,msg(str`Email addresses do not match`));
            this.submitButton.disabled = true;
        }
        else{
            validationHandlerClear(emailConfirmField);
            this.submitButton.disabled = false;
        }
    }

    _onPasswordChange(e){
        e.preventDefault();
        const passwordField = e.target;
        const passwordConfirmField = this.form.querySelector('#password_confirm');

        // Validate password itself
        validationHandlerClear(passwordField);
        const passwordValid = validatePassword(passwordField.value);
        if(passwordValid !== true){
            const error_message = passwordValid.join('<br>');
            validationHandler(passwordField, error_message);
        }

        // Validate password match
        validationHandlerClear(passwordConfirmField);
        if(passwordConfirmField.value && passwordConfirmField.value !== passwordField.value){
            validationHandler(passwordConfirmField,msg(str`Passwords do not match`));
        }
    }

    _onPasswordConfirmChange(e){
        e.preventDefault();
        const passwordConfirmField = e.target;
        const passwordField = this.form.querySelector('#password');

        validationHandlerClear(passwordConfirmField);
        if(passwordConfirmField.value !== passwordField.value){
            validationHandler(passwordConfirmField,msg(str`Passwords do not match`));
        }
    }

    async _signup(e) {
        e.preventDefault();

        // Check password match before running full validation
        const passwordField = this.form.querySelector('#password');
        const passwordConfirmField = this.form.querySelector('#password_confirm');
        if(passwordField.value !== passwordConfirmField.value){
            validationHandler(passwordConfirmField,msg(str`Passwords do not match`));
        }

        // Check Terms and Conditions checkbox
        const termsCheckbox = this.form.querySelector('#platform');
        if (!termsCheckbox.checked) {
            const errorMsg = 'You must agree to the Terms and Conditions.';
            const existingHtml = this.noticeArea.innerHTML;
            this.noticeArea.innerHTML = existingHtml + `<p class="error">${errorMsg}</p>`;
        }
        // END Check Terms and Conditions checkbox

        let valid = validateForm(this.form,this.formResponse);

        // If T&C checkbox not checked, mark form as invalid
        if (!termsCheckbox.checked) valid = false;

        if(!valid) {
            const formContainer = this.form.closest('.signup-form') || this.form;
            formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return;
        }
        let formData = new FormData(this.form);
        formData = JSON.stringify(Object.fromEntries(formData));
        this.noticeArea.innerHTML = '';
        this.form.classList.add('loading');
        this.submitButton.disabled = true;
        this.form.setAttribute('aria-busy', 'true');
        let gTokenValid  = await gRecaptcha(this.formResponse,this.action,this.nonce); 
        if(!gTokenValid){
            this.form.classList.remove('loading');
            this.form.setAttribute('aria-busy', 'false');
            this.submitButton.disabled = false;
            return; 
        }
        try{
            let response = await fetch(this.action, {
                method: 'POST',
                body: formData,
                headers: {
                    'Content-Type': 'application/json',
                    'AllIn-Nonce': this.nonce,
                    'AllIn-Signup': 'signup'
                }
            })
            response = await response.json();
            if(response.ok){
                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                window.location.href = this.successRedirect;
            }
            else{
                this.noticeArea.innerHTML = `<p class="error">${response.message}</p>`;

                //New validation for password mismatch to replace the generic error message with a more specific message
                const passwordField = this.form.querySelector('#password');
                const passwordConfirmField = this.form.querySelector('#password_confirm');

                if (passwordField.value !== passwordConfirmField.value) {
                    this.noticeArea.innerHTML = `<p class="error">${msg(str`Passwords do not match`)}</p>`;
                }

                //highlight email field for server side errors
                if (response.message.toLowerCase().includes('email')) {
                    const emailField = this.form.querySelector('#email');
                    validationHandler(emailField, response.message);
                }

                this.form.classList.remove('loading');
                this.form.setAttribute('aria-busy', 'false');
                this.submitButton.disabled = false; 
                // Scroll to top so the error is visible
                const formContainer = this.form.closest('.signup-form') || this.form;
                formContainer.scrollIntoView({ behavior: 'smooth', block: 'start' });
            }
        }
        catch(error){
            console.error('Error:', error);
        };
    }

    static styles = [
        accessibility,
        formStyles,
        css`
        .signup-form{
            width:680px;
            max-width:85vw;
            margin:0 auto;
        }
        .bg{
            padding:var(--allin-padding,2rem);
            background-color:var(--allin-bg-color,#ccc);
            margin-bottom:0.5rem;
        }
        .small{
            font-size:0.875rem;
        }

        fieldset{
            border:0;
            padding:0;
            margin:0;
        }

        legend{
            font-size:1.25rem;
            font-weight:700;
            margin-bottom:1rem;
            color:var(--allin-highlight-color,#472961);
        }
        legend:has(+p){
            margin-bottom:0.5rem;
        }
        .input-group:has(>input[type=checkbox],>input[type=radio]){
            justify-content:flex-start;
            
        }
        div:has(>allin-tooltip){
            position:relative;
            display:flex;
            justify-content:space-between;
            flex-wrap:wrap;
        }

        div:has(>allin-tooltip) label{
            width:fit-content;
        }
        input[type=checkbox]:disabled{
            filter: brightness(0.6) contrast(9);
        }
        `
        ];
}